import { PlanPrivacy, PlanType } from "common/app-plans";
import { getNamedIcon } from "common/named-icons";
import { useBuilderTheme } from "hooks/use-builder-theme";

import { IconImage } from "common/components/SerializedApp";
import { styled } from "sharedUI/styles";
import AppPlanIcon from "./app-plan-icon";
import { GlideFC } from "lib/glide-fc";

const AppPlanHeaderContainer = styled.div`
    position: relative;
    height: 140px;
    > .grid-background {
        svg {
            width: 100%;
        }
    }
    > .device-image {
        position: absolute;
        top: 27px;
        left: 34px;
        height: 140px;
    }
    > .app-icon {
        position: absolute;
        bottom: 0px;
        left: 31px;
    }
`;

interface Props {
    plan: PlanType;
    privacy: PlanPrivacy;
    appAccentColor: string;
    appIcon: IconImage;
}

const AppPlanHeader: GlideFC<Props> = p => {
    const { plan, privacy, appAccentColor, appIcon } = p;

    const theme = useBuilderTheme();

    const Grid = plan === PlanType.Pro ? getNamedIcon("gridTight") : getNamedIcon("gridLoose");

    const isPublicPro = plan === PlanType.Pro && privacy === PlanPrivacy.Public;
    const isPrivatePro = plan === PlanType.Pro && privacy === PlanPrivacy.Private;

    let appImage = "basic-plan-icon.png";
    if (isPublicPro) {
        appImage = "pro-plan-icon.png";
    } else if (isPrivatePro) {
        appImage = "private-pro-plan-icon.png";
    }

    return (
        <AppPlanHeaderContainer>
            <div className="grid-background">
                <Grid fgColor={theme.borderColorLight} />
            </div>
            <img className="device-image" src={`/images/${appImage}`} alt="Basic Plan" />
            <div className="app-icon">
                <AppPlanIcon
                    size={48}
                    appAccentColor={appAccentColor}
                    appIcon={appIcon}
                    shadow={false}
                    plan={plan}
                    privacy={privacy}
                />
            </div>
        </AppPlanHeaderContainer>
    );
};

export default AppPlanHeader;
